import { SeCommonConfig } from './../SeCommonConfig.class';
import { IBaseSEConfig } from '../base-se-config.interface';
import * as _ from 'lodash';

export class SeLimitedTimeOfferConfig extends SeCommonConfig implements IBaseSEConfig {

  // settings just for this element
  public SeType = 'SeLimitedTimeOffer';
  public backgroundColor = null;
  public ltoId = null;
  public fontSize = 10;

  constructor(jsonString?: string) {
    super();
    if (jsonString) {
      this.fromJsonString(jsonString);
    }
  }

  // create json from class vars
  toJson() {
    const obj = super.toJson(); // process common base config settings
    // and any custom props
    obj.backgroundColor = this.backgroundColor;
    obj.ltoId = this.ltoId;
    obj.fontSize = this.fontSize;
    obj.SeType = this.SeType;
    return obj;
  }

  // parse json to class vars
  fromJson(obj) {
    super.fromJson(obj); // process common base config settings

    // add custom props
    this.backgroundColor = _.get(obj, 'backgroundColor', null);
    this.ltoId = _.get(obj, 'ltoId', ''); // get val in safe way with defalut
    this.fontSize = _.get(obj, 'fontSize', 10);
    this.SeType = _.get(obj, 'SeType', 'SeLimitedTimeOffer');
  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }

  fromJsonString(str) {
    this.fromJson(JSON.parse(str));
  }



}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-limited-time-offer/se-limited-time-offer-config.class.ts